import {Http} from 'vue-resource'
import config from '../config'

class JobService {
  getJobNameSuggestions (q) {
    return Http.get(config.API_URL + 'module/ext/nl/Jobdigger', {params: {q}})
  }
}

const instance = new JobService()

export default instance
